import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationBar from './components/Navbar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Menu from './pages/Menu';
import Footer from './components/Footer';
import RentalHome from './pages/RentalHome';
import CookieConsent from './components/CookieConsent'; // import komponentu
import './App.css';

const App = () => {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (accepted) setCookiesAccepted(true);
  }, []);

  return (
    <Router>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        {/* Przekazujemy cookiesAccepted do Contact */}
        <Route path="/kontakt" element={<Contact cookiesAccepted={cookiesAccepted} />} />
        <Route path="/rowery-elektryczne" element={<RentalHome cookiesAccepted={cookiesAccepted} />} />
      </Routes>
      <Footer />
      {!cookiesAccepted && <CookieConsent onAccept={() => setCookiesAccepted(true)} />}
    </Router>
  );
};

export default App;
